'use client';

import useWindowSize from '@/client/hooks/useWindowSize';
import { useOverlayStore } from '@/client/stores/useOverlayMenuStore';
import Overlay from '@/features/Overlay';
import { easings } from '@/utils/animations';
import { AnimatePresence, motion } from 'motion/react';
import { usePathname } from 'next/navigation';
import { ReactNode, useEffect } from 'react';

interface Props {
  children?: ReactNode;
}

const OverlayContainer = ({ children }: Props) => {
  const { isOpen, setIsOpen } = useOverlayStore();
  const { windowSize } = useWindowSize();
  const pathname = usePathname();

  useEffect(() => {
    setIsOpen(false);
  }, [pathname, setIsOpen]);

  useEffect(() => {
    if (windowSize.width >= 1024) {
      setIsOpen(false);
    }
  }, [setIsOpen, windowSize]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.section
          key="overlayMenu"
          className="fixed left-0 top-0 w-full h-full"
          initial={{ y: '-100dvh' }}
          animate={{ y: 0, transition: { duration: 1, ease: easings.easeOutQuart } }}
          exit={{ y: '-100dvh', transition: { duration: 0.3 } }}
        >
          <Overlay className="bg-white dark:bg-black" onClick={() => setIsOpen(false)}>
            {children}
          </Overlay>
        </motion.section>
      )}
    </AnimatePresence>
  );
};

export default OverlayContainer;
